// extracted by mini-css-extract-plugin
module.exports = {"root":"NoteBlockEditor_root__Xy6V6"};